import { render, staticRenderFns } from "./HistoryLog.vue?vue&type=template&id=2fd53e7f&scoped=true&"
import script from "./HistoryLog.vue?vue&type=script&lang=js&"
export * from "./HistoryLog.vue?vue&type=script&lang=js&"
import style0 from "./HistoryLog.vue?vue&type=style&index=0&id=2fd53e7f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd53e7f",
  null
  
)

export default component.exports